import { AxiosInstance } from 'axios';
import { StaffingLevelsRepository } from '@/model/repository/shift/StaffingLevelsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): StaffingLevelsRepository => ({
    index() {
      return Repository.get(`${resource}`, { data: { errorHandle: false } });
    },
    update(payload) {
      return Repository.put(`${resource}`, payload);
    },
  });
